import React from 'react';
import {classes, style} from './doppe-action-type-widget-inner-button.st.css';
import {Button, DoubleRingSpinner, flexCenterContent, flexColumn, Icon, reactCreateMemo} from '@wix/devzai-utils-react';
import {cssBymoPageFontSizeActionInnerButtonTitle} from "../bymo-page-style/bymo-page-style";

export const DoppeActionTypeWidgetInnerButton = reactCreateMemo(function DoppeActionTypeWidgetInnerButton(
    props: DoppeActionTypeWidgetInnerButton.Props
) {
    const {
        isLoading,
        children,
        disabled,
        inPopup = false,
        suffixIcon,

        className,
        ...htmlAttributes
    } = props;

    return (
        <Button
            {...htmlAttributes}
            className={style(classes.root, {
                inPopup: inPopup,
                hasSuffixIcon: suffixIcon !== undefined,
            }, className, flexCenterContent())}
            disabled={disabled || isLoading}
        >
            <div
                className={style(classes.textContent, {}, cssBymoPageFontSizeActionInnerButtonTitle(), flexColumn())}
            >
                {children}
            </div>

            {
                suffixIcon ?
                    <Icon
                        className={style(classes.suffixIcon, {})}
                        icon={suffixIcon}
                    />
                    :
                    null
            }
            {isLoading ? (
                <div
                    className={style(classes.loadingState, {})}
                >
                    <DoubleRingSpinner
                        className={style(classes.spinner, {})}
                    />
                    {'Please Wait...'}
                </div>
            ) : null}
        </Button>
    );
});

export namespace DoppeActionTypeWidgetInnerButton {

    export interface Props extends Button.Props {
        isLoading?: boolean;
        inPopup?: boolean;
        suffixIcon?: Icon.Src;
    }

}
